import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Close from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'

const size = 32

const styles = theme => ({
  root: {
    height: size,
    width: size,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.tertiary.main,
    borderRadius: size / 2,
    cursor: 'pointer',
    transition: 'all .3s ease',
    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
    },
  },
  icon: {
    height: size / 2,
    width: size / 2,
    fill: theme.palette.white,
  },
})

const CloseButton = ({
  classes, className, iconClassName, onClick 
}) => (
  <IconButton
    className={classNames(classes.root, className)}
    onClick={onClick}
    aria-label="Close">
    <Close className={classNames(classes.icon, iconClassName)} />
  </IconButton>
)

CloseButton.defaultProps = {
  size: 32,
}

CloseButton.propTypes = {
  size: PropTypes.number,
  onClick: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
}

export default withStyles(styles)(CloseButton)



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/CloseButton.js